import ReplayIcon from '@material-ui/icons/Replay';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import React, { createRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import videoSourceMP4 from '../../upload/film.mp4';
import videoSourceWEBM from '../../upload/film.webm';
import Sound from '../../upload/sound.mp3';
import BigTitles from '../BigTitles/BigTitles';
import Cursor from '../Cursor/Cursor';
import Header from '../Header/Header';
import Intro from '../Intro/Intro';
import Zoom from '../Zoom/Zoom';
import Zoom1 from '../Zoom/Zoom1';
import Zoom2 from '../Zoom/Zoom2';
import Zoom3 from '../Zoom/Zoom3';
import classes from './BackgroundVideo.module.scss';
import { Music } from './Music';

const videoduration = 62.5625;
const coef = videoduration / 100;

const sections = [
	{ title: 'Histoire', zoom: Zoom1, end: 16.13 },
	{ title: 'Valeurs', zoom: Zoom2, end: 35.7 },
	{ title: 'Exigence', zoom: Zoom3, end: videoduration },
	{ title: 'Meilleurs vœux' },
];

const titles = [
	{ title: [], end: 1 },
	{ title: ['Créer de la valeur', 'durable'], end: 8 },
	{ title: ['Investir dans', 'les territoires'], end: 15 },
	{ title: ['Agilité'], subtitle: 'au cœur de notre façon de faire', end: 22 },
	{
		title: ['Créativité'],
		subtitle: "le moteur de notre façon d'être",
		end: 29,
	},
	{
		title: ['Exigence'],
		subtitle: 'la base de notre façon de réussir',
		end: 35,
	},
	{ title: ['Construire', 'une société', 'durable'], end: 42 },
	{ title: ['Offrir des services', 'de qualité'], end: 50 },
	{ title: ['Soutenir', "l'innovation"], end: 60 },
	{
		title: [
			'Le Groupe Duval vous présente',
			"ses meilleurs vœux pour l'année 2021",
		],
		end: videoduration + 10,
	},
];

const music = new Music(Sound);

class BackgroundVideo extends React.Component {
	state = {
		introClosed: false,
		showZoom: false,
		currenttime: 0,
		volume: true,
	};

	video = createRef();
	zoom = createRef();

	CloseIntro = () => {
		music.play();
		this.video.current.play();
		this.setState({ introClosed: true });
	};

	OpenZoom = () => {
		music.pause({ withFade: true });
		this.video.current.pause();
		this.setState({ showZoom: true });
	};

	CloseZoom = () => {
		music.play({ withFade: true });
		this.video.current.play();
		this.setState({ showZoom: false });
	};

	ToggleVolume = () => {
		if (this.state.volume) music.mute();
		else music.unmute();
		this.setState({ volume: !this.state.volume });
	};

	render() {
		const activeTitle =
			titles.find((t) => t.end > this.state.currenttime) ||
			titles[titles.length - 1];

		const activeSection =
			sections.find((s) => s.end > this.state.currenttime) ||
			sections[sections.length - 1];

		const videoEnded = activeTitle === titles[titles.length - 1];

		return (
			<>
				<Header />

				{/* Intro */}
				<Intro closed={this.state.introClosed} onClose={this.CloseIntro} />

				{/* Volume icon */}
				<div className={classes.VolumeContainer} onClick={this.ToggleVolume}>
					{this.state.volume === true ? (
						<VolumeOffIcon className={classes.Volume} />
					) : (
						<VolumeUpIcon className={classes.Volume} />
					)}
				</div>

				{/* Video */}
				<video
					playsInline
					ref={this.video}
					id="video_player"
					className={[classes.Video, videoEnded && classes.fadedOut]
						.filter(Boolean)
						.join(' ')}
					onTimeUpdate={(e) => {
						this.setState({ currenttime: e.target.currentTime });
					}}
				>
					<source src={videoSourceMP4} type="video/mp4" />
					<source src={videoSourceWEBM} type="video/webm" />
				</video>

				<div
					onClick={this.OpenZoom}
					className={[
						classes.Container,
						!this.state.introClosed && classes.hidden,
					]
						.filter(Boolean)
						.join(' ')}
				>
					{/* Content */}
					<div className={[classes.Content].filter(Boolean).join(' ')}>
						{/* Big titles */}
						<BigTitles
							videoEnded={videoEnded}
							activeTitle={activeTitle}
							hidden={this.state.showZoom}
						/>

						{/* Timeline
						<Timeline
							coef={coef}
							sections={sections}
							hidden={!this.state.introClosed}
							activeSection={activeSection}
							currentTime={this.state.currenttime}
						/> */}
					</div>
				</div>

				{/* Zoom */}
				<CSSTransition
					unmountOnExit
					timeout={500}
					nodeRef={this.zoom}
					classNames={classes}
					in={this.state.showZoom && !videoEnded}
				>
					<div className={classes.zoom} ref={this.zoom}>
						<Zoom zoom={activeSection.zoom} onClose={this.CloseZoom} />
					</div>
				</CSSTransition>

				{/* Outro */}
				<div
					title="Rejouer l'expérience"
					onClick={() => window.location.reload()}
					className={[classes.outro, !videoEnded && classes.hidden]
						.filter(Boolean)
						.join(' ')}
				>
					<ReplayIcon />
				</div>

				{/* Cursor */}
				<Cursor
					activeSection={activeSection}
					state2={!this.state.introClosed || this.state.showZoom || videoEnded}
				/>
			</>
		);
	}
}

export default BackgroundVideo;
